// TreatmentDetail.js - Estatica Skin and Laser
import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import "../../../assets/css/customer/screens/treatments/CardsDetail.css";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const TreatmentDetail = () => {
 
  const navigate = useNavigate();
  const { baseUrl , baseUrlForFile,selectedTreatmentFromLandingPage} = useContext(AppContext);
  const [treatment, setTreatment] = useState(null);

  useEffect(() => {

    console.log(selectedTreatmentFromLandingPage);
}, []);


  if (!selectedTreatmentFromLandingPage) {
    return (
      <>
      <MyNavbar/>
      <section className="estatica-detail">
        <Container>
          <div className="estatica-detail__not-found">
            <p>Treatment not found.</p>
            <button
              className="estatica-detail__back-btn"
              onClick={() => navigate("/treatments")}
            >
              ← Back to Treatments
            </button>
          </div>
        </Container>
      </section>
      <Footer/>
      </>
    );
  }

  return (
    <>
    <MyNavbar/>
    <section className="estatica-detail">
      <Container>
        {/* Back Button */}
        <button
          className="estatica-detail__back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back to Treatments
        </button>

        <Row className="align-items-center">
          {/* Left: Big Image */}
          <Col lg={6} md={12} className="mb-4 mb-lg-0">
            <div className="estatica-detail__img-wrapper">
              <img  src={`${baseUrlForFile}/${selectedTreatmentFromLandingPage.image}`} alt={selectedTreatmentFromLandingPage.name} />
            </div>
          </Col>

          {/* Right: Content */}
          <Col lg={6} md={12}>
            <div className="estatica-detail__content">
              <p className="estatica-detail__category">{selectedTreatmentFromLandingPage?.tagline}</p>

              <h1 className="estatica-detail__name">{selectedTreatmentFromLandingPage?.name}</h1>

              <p className="estatica-detail__full-desc">{selectedTreatmentFromLandingPage?.description}</p>

              {/* Price & Duration */}
              <div className="estatica-detail__meta">
                <div className="estatica-detail__meta-item">
                  <span className="estatica-detail__meta-label">Duration</span>
                  <span className="estatica-detail__meta-value">
                    {selectedTreatmentFromLandingPage?.duration}
                  </span>
                </div>
                <div className="estatica-detail__meta-item">
                  <span className="estatica-detail__meta-label">Price</span>
                  <span className="estatica-detail__meta-value">
                    {selectedTreatmentFromLandingPage?.price}
                  </span>
                </div>
              </div>

              {/* Book Now Button */}
         <button
             className="estatica-detail__book-btn"
             onClick={() =>
             navigate(
               localStorage.getItem("customerToken")
                  ? "/customer/dashboard"
                  : "/customer/login"
                 )}
                >
                   Book Now
          </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
    <Footer/>
    </>
  );
};

export default TreatmentDetail;